import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoArrowLeft } from 'react-icons/go';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, label }) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('common.back');

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={resolvedLabel}
      className="flex items-center space-x-2 rounded px-2 py-1 transition hover:bg-white/20 hover:opacity-95 hover:shadow-sm focus:ring-2 focus:ring-white/30 focus:outline-none md:cursor-pointer"
    >
      <GoArrowLeft className="size-5 transition-transform group-hover:-translate-x-1" />
      <span>{resolvedLabel}</span>
    </button>
  );
};

export default BackButton;
